import { reject, isArray, isObject, isEqual, omit } from 'lodash';


const shouldRemoveKey = (value, {
  removeUndefinedValue = false,
  removeNullValue = false,
  removeEmptyObjectValue = false,
  removeEmptyArrayValue = false,
  removeEmptyStringValue = false
} = {}) => {
  return (removeUndefinedValue && undefined === value)
    || (removeNullValue && null === value)
    || (removeEmptyObjectValue && isEqual(value, {}))
    || (removeEmptyArrayValue && isEqual(value, []))
    || (removeEmptyStringValue && '' === value);
};

const removeKeys = (collection, {
  removeUndefinedValue = false,
  removeNullValue = false,
  removeEmptyObjectValue = false,
  removeEmptyArrayValue = false,
  removeEmptyStringValue = false
} = {}) => {
  const removeOptions = {
    removeUndefinedValue,
    removeNullValue,
    removeEmptyObjectValue,
    removeEmptyArrayValue,
    removeEmptyStringValue
  };

  if (isArray(collection)) {
    return reject(collection, (value) => {
      return shouldRemoveKey(value, removeOptions);
    });
  } if (isObject(collection)) {
    return omit(collection, (value) => {
      return shouldRemoveKey(value, removeOptions);
    });
  }

  return undefined;
};

export default removeKeys;
